import React, { Component } from 'react';
//import logo from './logo.svg';
import './App.css';
import {Button, Header, Form, Segment} from 'semantic-ui-react'

class SignIn extends Component {
  render() {
    return (

        <div className="SignInForm">
            <Segment.Group>
                <Segment color='green'>
                    <Header as='h3' color="green" >Sign In</Header>

                    <Form id="signinForm">
                        <Form.Group>
                            <Form.Input fluid type="email" id="emailInputSignin" placeholder="Email" required width={4} />
                            <Form.Input fluid type="password" id="passwordInputSignin" placeholder="Password" pattern=".*" required width={4} />
                            <Form.Button color='green' type="submit">Sign in</Form.Button>
                        </Form.Group>

                    </Form>
                </Segment>
                <Segment.Group horizontal>
                    <Segment textAlign='center'>
                        <span className="small text">Dont have an account yet? &nbsp;<Button basic onClick={this.navigateToRegister}><b>Register</b></Button></span>
                    </Segment>
                    <Segment textAlign='center'>
                        <span className="small text">Need to verify your account? &nbsp;<Button basic onClick={this.navigateToVerify}><b>Verify</b></Button></span>
                    </Segment>
                </Segment.Group>
            </Segment.Group>
        </div>



    );
  }
  navigateToVerify = (event) => {
      this.props.changeFunction("Verify");
  }

  navigateToRegister = (event) => {
      this.props.changeFunction("Register");
  }
}

export default SignIn;



// WEBPACK FOOTER //
// ./src/SignIn.js